//
//
//
//
//
//
//
//
//
//

import {
  Cascader,
  DatePicker,
  Input,
  InputNumber,
  MultiSelectPopup,
  Select,
  Span,
  Textarea,
  Upload,
} from '@/constant/componentConfig'
import { ACCEPT_FILE } from '@/constant/dict'
import {
  BASE_API_URL,
  post,
} from '@/utils/http'
import { uploadAttachment } from '@/https/enroll'
import { cloneDeep } from '@/utils/lodash'
import {
  Identity,
  MaxLength,
  MinLength,
  Phone,
  MailCode,
  PostalCode,
  QQ,
  Range,
} from '@/utils/validatorClass'
import * as validateField from './share'

const NOT_EDIT_FIELD_1 = [
  'dzlbdm',
  'xm',
  'zjlxdm',
  'csny',
  'xbdm',
  'zjhm',
]

const NOT_EDIT_FIELD_2 = [
  'dzlbdm',
  'xm',
  'zjlxdm',
  'zjhm',
]

export default {
  props: {
    options: {
      type: Object,
      default: () => ({}),
    },

    filterConfigMethod: { type: Function },

    readonly: {
      type: Boolean,
      default: false,
    },
  },

  data () {
    return { formData: { zjlxdm: '' } }
  },

  computed: {
    baseInfoRenderData () {
      let config = []

      if (this.filterConfigMethod) {
        config = this.filterConfigMethod(this.options)
      } else {
        config = this.options.bmbMbDetailItem?.bmbMbzdList || []
      }

      const zjlxdm = this.options?.ksxxItem?.zjlxdm

      return this.filterRelationField(config).filter((el) => el.sjlxdm)
        .map((el) => {
          return this.getFieldComponentProps(el, zjlxdm)
        })
    },
  },

  watch: {
    options: {
      handler (val) {
        this.formData = { ...(this.options.ksxxItem || {}) }
      },
      immediate: true,
      deep: true,
    },

    formData: {
      handler (val) {
        this.$emit('update:model', cloneDeep(val))
      },
      immediate: true,
      deep: true,
    },
  },

  methods: {
    filterRelationField (data = []) {
      return data.map((el) => {
        let clear = []
        clear = data.filter((item) => item.glzddm === el.zddm).map((el) => el.zddm)

        return {
          ...el,
          clear,
        }
      })
    },

    isExit (value, allArr) {
      if (Array.isArray(value)) { // 多选
        return allArr?.some((val) => value?.indexOf(val) >= 0)
      } else { // 单选
        return allArr?.indexOf(value) >= 0
      }
    },

    filterRelationShip (item) {
      const { glzddm, sjlxdm, gllj } = item

      if (!glzddm) {
        return {}
      }

      const params = {}
      const relationValue = this.formData[glzddm]
      const relationList = JSON.parse(gllj || '[]')

      if (validateField.isSelectMany(sjlxdm)) {
        let flag = false
        params.apiMethod = undefined

        relationList.forEach((el) => {
          if (this.isExit(relationValue, el?.relation)) {
            params.list = el.source
            flag = true
          }
        })

        if (!flag) {
          params.list = []
        }
      } else {
        if (!this.isExit(relationValue, relationList[0]?.relation)) {
          params.none = true
        }
      }

      return params
    },

    getFieldComponentProps (item, zjlxdm) {
      const { sjlxdm, jkdz, zdkxs, clear, sfbtdm, xsmc, zddm, xsmrz, zdmc, tssm, sfxsdm, xsw, cdsx, cdxx } = item

      if (this.formData.zddm === undefined && xsmrz) {
        this.$set(this.formData, zddm, xsmrz)
      }

      let disabled

      if (+zjlxdm === 1) {
        disabled = !!NOT_EDIT_FIELD_1.includes(zddm)
      } else {
        disabled = !!NOT_EDIT_FIELD_2.includes(zddm)
      }

      const name = xsmc || zdmc
      const readonlySettingFlag = +item.sfzddm === 1 || this.readonly
      let componentProps = {
        label: name,
        value: zddm,
        tip: tssm,
        disabled,
        readonly: readonlySettingFlag,
        required: !!+sfbtdm,
        clear,
        none: !(sfxsdm === null || +sfxsdm === 1 || sfxsdm === undefined),
      }

      if (!this.readonlySettingFlag || validateField.isUpload(sjlxdm)) {
        if (validateField.isSelect(sjlxdm)) {
          componentProps = {
            ...componentProps,
            ClassName: Select,
            valueName: 'key',
            labelName: 'value',
            filterable: true,
            remote: false,
            displayValue: this.formData[zddm.replace(/dm$/, 'mc')],
            labelFormat: '{value}',
            apiMethod: this.filterSelectMethodByUrl(jkdz),
          }
        }

        if (validateField.isMultiSelect(sjlxdm)) {
          this.formData[zddm] = typeof this.formData[zddm] === 'string' ? this.formData[zddm].split(',') : this.formData[zddm]
          componentProps = {
            ...componentProps,
            ClassName: MultiSelectPopup,
            valueName: 'key',
            labelFormat: '{value}',
            filterable: true,
            remote: false,

            // max: zdkxs,
            rules: [
              {
                validator: (rule, value, callback) => {
                  if (zdkxs && value?.length > zdkxs) {
                    callback(new Error(`最大选择数为${zdkxs}`))
                  } else {
                    callback()
                  }
                },
              },
            ],
            multi: true,
            apiMethod: this.filterSelectMethodByUrl(jkdz),
          }
        }

        if (validateField.isInputMany(sjlxdm)) {
          let rule = []

          if ((validateField.isInput(sjlxdm) || validateField.isSingleLineInput(sjlxdm)) && cdsx) {
            rule = [new MaxLength(name, cdsx)]
          }

          if ((validateField.isInput(sjlxdm) || validateField.isSingleLineInput(sjlxdm)) && cdxx) {
            rule = [new MinLength(name, cdxx)]
          }

          if (validateField.isIdentityInput(sjlxdm) && +this.formData.zjlxdm === 1) {
            rule = [new Identity(name)]
          }

          if (validateField.isPhoneInput(sjlxdm)) {
            rule = [new Phone(name)]
          }

          if (validateField.isEmailInput(sjlxdm)) {
            rule = [new PostalCode(name)]
          }

          if (validateField.isMailInput(sjlxdm)) {
            rule = [new MailCode(name)]
          }

          if (validateField.isQQInput(sjlxdm)) {
            rule = [new QQ(name)]
          }

          componentProps = {
            ...componentProps,
            ClassName: Input,
            row: validateField.isSingleLineInput(sjlxdm),
            rules: rule,
          }
        }

        if (validateField.isCascader(sjlxdm)) { // 树形
          if (zddm === 'zzzxWid') {
            componentProps.maxLevel = 2
          }

          componentProps = {
            ...componentProps,
            ClassName: Cascader,
            valueName: 'value',
            labelFormat: '{label}',
            immediate: true,
            apiMethod: this.filterSelectMethodByUrl(jkdz),
          }
        }

        if (validateField.isInputNumber(sjlxdm)) {
          const range = item.szqj?.split(',') || []
          const min = range[0]?.slice(1)
          const max = range[1]?.slice(0, -1)

          componentProps = {
            ...componentProps,
            ClassName: InputNumber,
            rules: (range?.length && !isNaN(min) && !isNaN(max)) ? [new Range(name, +min, +max, +xsw)] : [],
          }
        }

        if (validateField.isTextarea(sjlxdm)) { // 多行文本
          componentProps = {
            ...componentProps,
            ClassName: Textarea,
            row: true,
            maxlength: cdsx,
            showWordLimit: true,
            rules: [
              cdsx ? [new MaxLength(name, this.formData.cdsx)] : null,
              cdxx ? [new MinLength(name, this.formData.cdxx)] : null,
            ].filter((el) => el),
          }
        }

        if (validateField.isUpload(sjlxdm)) { // 附件
          componentProps = {
            ...componentProps,
            ClassName: Upload,
            fileCount: 1,
            accept: ACCEPT_FILE,
            multiple: false,
            needOnlyAddress: true,
            maxSize: 500 * 1024,
            row: true,
            apiMethod: uploadAttachment,
          }
        }

        if (validateField.isDatePicker(sjlxdm)) { //  日期选择
          componentProps = {
            ...componentProps,
            ClassName: DatePicker,
          }
        }
      } else {
        componentProps = {
          ...componentProps,
          ClassName: Span,
          value: zddm.replace(/dm$/, 'mc'),
        }
      }

      const ClassName = componentProps?.ClassName

      return new ClassName({
        ...componentProps,
        ClassName: '',
        ...this.filterRelationShip(item),
      })
    },

    filterSelectMethodByUrl (url) {
      return (...args) => {
        return post(BASE_API_URL + url, ...args)
      }
    },

    async validate () {
      const flag = await this.$refs.baseForm.validate()

      return flag
    },
  },
}
